import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import AnalyticsService from '@/services/AnalyticsService'

// ROUTES
import Loading from '@/views/Loading'
import SwipeUp from '@/views/SwipeUp'
import Intro from '@/views/Intro'
import Question from '@/views/Question'
import Result from '@/views/Result'
import Dossier from '@/views/Dossier'
import EndScreen from '@/views/EndScreen'
import NoAccess from '@/views/NoAccess'

// BASE
Vue.use(Router)

// INIT
const router = new Router({
  // ROUTER MODES
  // 'hash': eg /#/mypage
  // 'history': eg /mypage (requires htaccess or equivalent for deploy)
  // 'abstract': internal routing, no url change
  mode: 'abstract',
  routes: [
    {
      path: '/loading',
      name: 'loading',
      component: Loading
    }, 
    {
      path: '/no-access',
      name: 'no-access',
      component: NoAccess
    },
    {
      path: '/swipeup',
      name: 'swipeup',
      component: SwipeUp
    },
    {
      path: '/intro',
      name: 'intro',
      component: Intro
    },
    {
      path: '/question',
      name: 'question',
      component: Question
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    },
    {
      path: '/endscreen',
      name: 'endscreen',
      component: EndScreen
    },
    {
      path: '/dossier',
      name: 'dossier',
      component: Dossier
    }
  ],
})
export default router

// ROUTE GUARD

router.beforeEach((to, from, next) => {
  if (to.name !== 'loading' && !store.state.app.loading.completed) {
    if (typeof to.name === 'string' && to.name !== 'loading') {
      store.commit('app/setRouteAfterLoad', to.name)
    }
    return next({ name: 'loading' })
  }
  next()
})

// START IF ABSTRACT MODE
if (router.mode === 'abstract') {
  router.replace('/')
}

// AFTER HOOK
router.afterEach((to) => {
  store.commit('app/setRoute', {
    parent: to.matched[0].name,
    child: (to.matched[1] || { name: null }).name,
  })
 AnalyticsService.sendPageview(to.fullPath)
})

window.router = router
